/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { Token } from "../../store/global/TokenEnum";
import { Amount } from "../../types/amount";
import exchange from "../../img/exchange.svg";
import { ratesInfo } from "../../config/commonCSS";

/**
 *
 * We can probably have something smarter which checks number of decimals of the USD price,
 * this is specifically for values where only 1 token doesn't yield a great exchange and
 * so if we truncate the exchange rate to 5dp then you get 0.0000.
 */
export const ExchangeRate: React.FC<{
  symbol: Token;
  oppositeSymbol: Token;
  price: Amount;
  flippedPrice: Amount;
}> = ({ symbol, oppositeSymbol, price, flippedPrice }) => {
  const [switchRate, setSwitchRate] = useState(false);
  return (
    <>
      <div className="d-flex align-items-center">
        <div
          className="d-flex align-items-center"
          role="button"
          onClick={() => setSwitchRate(!switchRate)}
        >
          <div>
            <img src={exchange} className="me-2" alt={"Exchange rate"} />
          </div>
          {switchRate ? (
            <span css={ratesInfo}>
              {/* Do we need this? */}
              {symbol === "SHIB" ? "10000" : "1"} {symbol} = {flippedPrice.format(5)}{" "}
              {oppositeSymbol}
            </span>
          ) : (
            <span css={ratesInfo}>
              {oppositeSymbol === "SHIB" ? "10000" : "1"} {oppositeSymbol} = {price.format(5)}{" "}
              {symbol}
            </span>
          )}
        </div>
      </div>
    </>
  );
};
